import type { CustomFlowbiteTheme } from 'flowbite-react';

export const breadcrumbTheme: CustomFlowbiteTheme['breadcrumb'] = {
  root: {
    base: '',
    list: 'flex items-center',
  },
  item: {
    base: 'group flex items-center',
    chevron: 'mx-1 h-6 w-6 text-titan-night-400 group-first:hidden md:mx-2',
    href: {
      off: 'flex items-center text-sm font-medium text-titan-night-500',
      on: 'flex items-center text-sm font-medium text-titan-night-700 hover:text-titan-night-900',
    },
    icon: 'mr-2 h-4 w-4',
  },
};
